import type { ListingPayload, PriceFields, SalePayload, StoredEvent } from "./types";

export type ListingStatus = "listed" | "sold" | "cancelled" | "superseded";

export interface FeedListing {
  receivedAt: number;
  payload: ListingPayload;
  status: ListingStatus;
  saleBuyer?: string;
  saleSignature?: string;
  saleReceivedAt?: number;
  cancelInitiator?: "seller" | "admin";
  cancelSignature?: string;
  cancelReceivedAt?: number;
}

export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";

function key(mint: string, seller: string): string {
  return `${mint}|${seller}`;
}

export function buildFeed(events: StoredEvent[]): FeedListing[] {
  const listings: FeedListing[] = [];
  const activeByKey = new Map<string, FeedListing>();

  for (const ev of events) {
    const k = key(ev.payload.mint, ev.payload.seller);
    if (ev.payload.type === "listing") {
      const prev = activeByKey.get(k);
      if (prev && prev.status === "listed") {
        prev.status = "superseded";
      }
      const listing: FeedListing = {
        receivedAt: ev.receivedAt,
        payload: ev.payload,
        status: "listed",
      };
      activeByKey.set(k, listing);
      listings.push(listing);
    } else if (ev.payload.type === "sale") {
      const prev = activeByKey.get(k);
      if (prev && prev.status === "listed") {
        prev.status = "sold";
        prev.saleBuyer = ev.payload.buyer;
        prev.saleSignature = ev.payload.signature;
        prev.saleReceivedAt = ev.receivedAt;
        activeByKey.delete(k);
      }
    } else if (ev.payload.type === "cancellation") {
      const prev = activeByKey.get(k);
      if (prev && prev.status === "listed") {
        prev.status = "cancelled";
        prev.cancelInitiator = ev.payload.initiator;
        prev.cancelSignature = ev.payload.signature;
        prev.cancelReceivedAt = ev.receivedAt;
        activeByKey.delete(k);
      }
    }
  }
  return listings;
}

export function priceNative(p: PriceFields): number | null {
  if (p.paymentDecimals == null) return null;
  try {
    return Number(BigInt(p.priceRaw)) / 10 ** p.paymentDecimals;
  } catch {
    return null;
  }
}

export function priceUsd(p: ListingPayload | SalePayload): number | null {
  if (p.paymentSymbol === "USDC" || p.paymentMint === USDC_MINT) {
    return priceNative({ ...p, paymentDecimals: p.paymentDecimals ?? 6 });
  }
  return null;
}
